import React, { useRef, useState, useEffect } from 'react';
import styles from '../rhainarafisioterapeuta/rhainarafisioterapeuta.module.scss';
import Perfil from './src/perfil.png';
import LinkPersonalizado2 from '../../components/LinkPersonalizado2/linkPersonalizado2.tsx';
import catalogoPdf from './src/catalogo-rhainarafisioterapeuta.pdf';

const Rhainarafisioterapeuta: React.FC = () => {
    const imgRef = useRef<HTMLImageElement>(null);
    const [height, setHeight] = useState(window.innerHeight);

    useEffect(() => {
        const handleResize = () => {
            setHeight(window.innerHeight);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <div className={styles.rhainarafisioterapeuta}>
            <div className={styles["body-thunder"]} style={{ minHeight: `${height}px` }}>
                <div className={styles["background-thunder"]}></div>
                <div className={`${styles["container-thunder"]}`} >
                    <div className={styles["img-wrapper"]}>
                        <img
                            ref={imgRef}
                            className={styles["img-perfil"]}
                            src={Perfil}
                            alt="Profile Picture"
                        />
                    </div>
                    <h1 className="mt-4">RHAINARA | FISIOTERAPEUTA</h1>
                    <p className="mb-4">Você merece uma vida leve e sem dor! 🦋✨</p>
                    <div className={styles.links}>
                        <LinkPersonalizado2
                            href="https://www.instagram.com/rhainarafisioterapeuta?igsh=enR4ams0a3M3Nmxw"
                            title="Instagram"
                            backgroundColor="#889568"
                            backgroundColorHover="#72834c"
                            colorText="#889568"
                        />
                        <LinkPersonalizado2
                            href="https://wa.me/5517991947969?text=Ol%C3%A1%2C%20gostaria%20de%20agendar%20um%20hor%C3%A1rio."
                            title="Whatsapp"
                            backgroundColor="#889568"
                            backgroundColorHover="#72834c"
                            colorText="#889568"
                        />
                        <LinkPersonalizado2
                            href={catalogoPdf}
                            title="Catálogo"
                            backgroundColor="#889568"
                            backgroundColorHover="#72834c"
                            colorText="#889568"
                        />
                        <LinkPersonalizado2
                            href="https://maps.app.goo.gl/8j1ZzDrVUt4HVDzH9"
                            title="Localização"
                            backgroundColor="#889568"
                            backgroundColorHover="#72834c"
                            colorText="#889568"
                        />
                    </div>
                    <div className="mt-4">
                        <img width={250} src={require("./src/footer.png")} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Rhainarafisioterapeuta;
